import { patternToSheetSegment } from './patternToSheet';
import { segmentToAbc } from './sheetToAbc';
export function patternToAbc(pattern, abcTick = 8, useRepeats = true) {
    const segment = patternToSheetSegment(pattern);
    const [abc] = segmentToAbc(segment, abcTick, useRepeats);
    return abc;
}
//# sourceMappingURL=patternToAbc.js.map